module.exports = __webpack_public_path__ + "static/img/g_head_ok.87aa40dc.webp";